module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.orderDetailsModal),
      callback: function($$v) {
        _vm.orderDetailsModal = $$v
      },
      expression: "orderDetailsModal"
    }
  }, [(_vm.order.id !== undefined) ? _c('v-card', {
    staticClass: "pl-5 pr-5 no-details"
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-4 pb-3"
  }, [_c('v-flex', [_c('span', {
    staticClass: "mt-2 mb-2 headline"
  }, [_vm._v("Pedido ref.: ")]), _c('span', {
    staticClass: "titulo-detalhes mt-2 mb-2 headline"
  }, [_vm._v(" " + _vm._s(_vm.order.identifier) + " ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right "
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.orderDetailsModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-form', {
    ref: "scheduleForm"
  }, [_c('v-layout', {
    staticClass: "pt-3 mb-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes"
  }, [_vm._v("\n              Itens do pedido\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_vm._v("\n              " + _vm._s(_vm._f("orderDateFilter")(_vm.order.date)) + "\n            ")])], 1), _vm._v(" "), _vm._l((_vm.order.itens), function(item, index) {
    return [_c('v-layout', {
      key: index,
      class: {
        'pt-1 pb-1': true, 'divider-item': index !== _vm.order.itens.length - 1
      },
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      staticClass: "order-color"
    }, [_c('strong', [_vm._v("Qtde: " + _vm._s(item.count))]), _c('br')]), _vm._v(" "), _c('v-flex', {
      staticClass: "order-color"
    }, [_c('strong', [_vm._v(" " + _vm._s(item.name))]), _c('br')]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      staticClass: "order-color text-xs-right"
    }, [_c('strong', [_vm._v(" Valor Unit: " + _vm._s(_vm._f("currency")(item.price)))]), _c('br')]), _vm._v(" "), _c('v-flex', {
      staticClass: "order-color text-xs-right"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")((item.price * item.count))))]), _c('br')])], 1)]
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-3 mb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_c('v-flex', {
    staticClass: "text-xs-right"
  }, [_vm._v("Valor total: " + _vm._s(_vm._f("currency")(_vm.totalPrice)))])], 1)], 1), _vm._v(" "), (_vm.order.payment !== '') ? _c('v-layout', {
    staticClass: "payment-method mb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n              Método de pagamento: " + _vm._s(_vm.order.payment) + "\n            ")])], 1) : _c('v-layout', {
    staticClass: "mb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_c('hr', {
    staticClass: "divider-red"
  })])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              Endereço\n            ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "order-color",
    attrs: {
      "xs10": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.order.condominium.name)), _c('br'), _vm._v("\n              " + _vm._s(_vm.order.condominium.address) + ", " + _vm._s(_vm.order.condominium.city) + " - " + _vm._s(_vm.order.condominium.state) + ", " + _vm._s(_vm.order.condominium.zipCode) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('a', {
    staticClass: "get-map",
    attrs: {
      "target": "_blank",
      "href": 'https://www.google.com.br/maps/place/' + _vm.order.condominium.address
    }
  }, [_vm._v("\n                Como chegar\n              ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              Solicitante\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.order.client) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              Unidade: " + _vm._s(_vm.order.unit) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              E-mail: " + _vm._s(_vm.order.email) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              Telefone: " + _vm._s(_vm.order.phone) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              Data de realização: " + _vm._s(_vm._f("dataPrevista")(_vm.order.dateChoosen)) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n              Hora de realização: " + _vm._s(_vm._f("horaPrevista")(_vm.order.timeChoosen)) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("\n                Observações:\n              ")]), _vm._v("\n              " + _vm._s(_vm.order.comments) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("\n                Plataforma de origem do pedido:\n              ")]), _vm._v("\n              " + _vm._s(_vm.order.origin) + "\n            ")])], 1), _vm._v(" "), (false) ? _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('hr')])], 1) : _vm._e(), _vm._v(" "), (_vm.showOrderBtns) ? _c('v-layout', {
    staticClass: "pt-3 mb-3 text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "red",
      "disabled": _vm.loadingOrderActions
    },
    on: {
      "click": _vm.cancelOrder
    }
  }, [_vm._v("Recusar pedido")])], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "blue",
      "disabled": _vm.loadingOrderActions
    },
    on: {
      "click": function($event) {
        return _vm.printOrder(_vm.order.id)
      }
    }
  }, [_vm._v("Imprimir pedido")])], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "green",
      "disabled": _vm.loadingOrderActions
    },
    on: {
      "click": _vm.acceptOrder
    }
  }, [_vm._v("Aceitar pedido")])], 1)], 1) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.loadingOrderActions) ? _c('v-progress-linear', {
    staticClass: "loading-modal",
    attrs: {
      "color": "error",
      "indeterminate": true
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07aebe5d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/sharedComponents/orderDetails/index.vue
// module id = 726
// module chunks = 6